import selfHtml from './s52-msg_read.html' with { type: 'text' };;

var msg_rcv_decrypted;
var msg_rcv_encrypted;
var message_key_type
var apishare_response;
var message_remaining_ttl;
var btn_delete_message;
var passwordMessage;
var urlMessage;
var downloadFileMessage;

var sender_pubkey = ""; // start with an invalid key to avoid "null", as it could be interpeted as self-key

var message_quorum_psk = null; // The PSK protcted by SSS

var matrix_effect_node;

var hkey;

var root;

import { mod_loader, BASEURL, KeyDetailsModule, MsgComposeModule, EndorseModule, PrivKeyLinkScanModule } from "../AppState.js";
import { decrypt_gpg, get_pub_key, pubkey_exists, add_pub_key, sign_gpg, is_my_pubkey } from "../crypt_helper.js"
import { collapse_show, copy_to_clipboard, postData, show_modal, sleep, matrix_effect, secondsToHuman } from "../utils.js";
import { read } from 'fs';


export async function init(module_root, module_hkey) {


    module_root.innerHTML = selfHtml;

    root = module_root

    hkey = module_hkey;

    msg_rcv_decrypted = root.querySelector("#msg_rcv_decrypted");
    msg_rcv_encrypted = root.querySelector("#msg_rcv_encrypted");
    message_key_type = root.querySelector(".message_key_type");
    message_remaining_ttl = root.querySelector(".message_remaining_ttl");
    btn_delete_message = root.querySelector(".btn_delete_message");
    passwordMessage = root.querySelector(".passwordMessage");
    urlMessage = root.querySelector(".urlMessage");
    downloadFileMessage = root.querySelector(".downloadFileMessage");

    root.querySelector(".btn_discard_key").addEventListener('click', () => ignore_key_and_decrypt());
    root.querySelectorAll(".copy_link_to_clipboard").forEach(el => el.addEventListener('click', e => copy_to_clipboard(e.currentTarget)));
    root.querySelector(".btn_ready_to_download").addEventListener('click', (event) => get_message(event));

    btn_delete_message.addEventListener('click', (event) => delete_message(event));

    root.querySelector(".btn_reply_message").addEventListener('click', () => mod_loader(MsgComposeModule, sender_pubkey));
    root.querySelector(".btn_add_contact_key").addEventListener('click', () => { add_key_and_decrypt(sender_pubkey) });

    root.querySelector(".show_hidden_password").addEventListener('click', () => { passwordMessage.type = 'text'; })

    matrix_effect_node = msg_rcv_decrypted.parentNode.parentNode.parentNode;
    
    new ResizeObserver((() => {
        msg_rcv_encrypted.style.height = msg_rcv_decrypted.style.height;
    })).observe(msg_rcv_decrypted)

}
// ---- ---- ---- ---- ---- ---- ---- ---- ---- ---- ---- ---- ----

export function init_read_message_quorum(event, sss_payload) {

    init(root, sss_payload.body);

    // Skip the 'continue' and download 
    root.querySelector(".section_download_ask").classList.remove("show");

    if (sss_payload?.secret_PSK.length != 128)
        console.warn("The PSK length is not valid.")

    message_quorum_psk = sss_payload.secret_PSK;

    get_message(event);

}
// ---- ---- ---- ---- ---- ---- ---- ---- ---- ---- ---- ---- ----
async function get_message(event) {

    const signature = await sign_gpg(JSON.stringify({ hkey }));

    const payload = { hkey, signature }

    const data = await postData(BASEURL.api + '/share_note', payload, event.target);

    root.querySelector(".section_download_ask").classList.remove("show");

    if (data.invalid_requester_signature == true) {
        event.target.disabled = true;
        root.querySelector(".section_message_403_panel").classList.add("show");
        return
    }

    if (!data.armoured_text) {
        event.target.disabled = true;
        root.querySelector(".section_message_404_panel").classList.add("show");
        root.querySelector(".section_message_404_id").innerText = hkey;
        return
    }

    apishare_response = data;

    read_message(data)
}
// ---- ---- ---- ---- ---- ---- ---- ---- ---- ---- ---- ---- ----
async function delete_message(event) {

    const payload = { "target_type": "message", hkey };

    const data = await postData(BASEURL.api + '/remove', payload);

    msg_rcv_decrypted.value = "";

    if (data.remove == 0)
        return show_modal("Delete message", "Message was already deleted")

    if (data.remove == 1)
        return show_modal("Delete message", "Message deleted")

    console.log(data);
    root.querySelector(".section_download_ask").classList.remove("show");
    root.querySelector(".section_message_read").classList.add("show");
    read_message(data)
}
// ---- ---- ---- ---- ---- ---- ---- ---- ---- ---- ---- ---- ----
async function read_message(data) {

    root.querySelector(".section_message_read").classList.add("show");

    matrix_effect(matrix_effect_node, true, "DECRYPTING...");

    // await sleep(500);

    msg_rcv_encrypted.value = data.armoured_text;

    const my_key = await get_pub_key();

    sender_pubkey = await get_pub_key(data?.pgp_pubkey)

    const is_rcpt_myself = await is_my_pubkey(my_key?.myKeyPairFingerprint, data.pgp_pub_rcpt);

    if (data.is_message_destroyed) {
        root.querySelector(".message_autodestruct").classList.add("show");
        btn_delete_message.style.display = "none";
        apishare_response.ttl_remaining = 10;
    }
    else {
        root.querySelector(".message_autodestruct").classList.remove("show");
        btn_delete_message.style.display = "";
    }

    root.querySelector(".message_from").innerText = sender_pubkey?.myKeyPairUserID[0];
    root.querySelector(".message_date").innerText = (new Date(apishare_response.creation_time)).toLocaleString();
    document.querySelectorAll('.placeholder').forEach(el => el.classList.remove('placeholder'));


    // check that the message is from myself, and the rcpt is somebody else
    if (my_key
        && sender_pubkey.myKeyPairFingerprint == my_key.myKeyPairFingerprint
        && is_rcpt_myself == false
        && data.pgp_pub_rcpt != null) {
        collapse_show(root.querySelector(".display_this_is_your_own_key"));
        matrix_effect(matrix_effect_node, false);
        matrix_effect(matrix_effect_node, true, "Decryption key required");
        document.querySelectorAll('.placeholder').forEach(el => el.classList.remove('placeholder'));
        return
    }

    const is_known_key = await pubkey_exists(sender_pubkey.myKeyPairPublicKey)

    if (is_known_key)
        decrypt_message()
    else {
        matrix_effect(matrix_effect_node, false);
        matrix_effect(matrix_effect_node, true, "Trust key to decrypt");

        await mod_loader(KeyDetailsModule, { target: ".div_key_details", key: sender_pubkey })

        collapse_show(root.querySelector(".add_pubkey_panel"))
    }

}

// ---- ---- ---- ---- ---- ---- ---- ---- ---- ---- ---- ---- ----
async function decrypt_message() {

    // In Direct messages the PSK in the URL #
    if (window.location.hash != '')
        apishare_response.secret_PSK = window.location.hash.substring(1);

    // In Quorum messages the PSK in the SSS
    if (message_quorum_psk != null)
        apishare_response.secret_PSK = message_quorum_psk;

    decrypt_gpg(apishare_response).then(async (decrypted) => {
        var key_type;
        switch (decrypted.is_asymmertic_encryption) {
            case true:
                key_type = "Aymmetric (PKI)"
                break
            case false:
                key_type = "Symmetric"
                break
            default:
                key_type = "Cannot decrypt"
        }

        message_key_type.innerText = key_type;

        if (decrypted.success == true) {
            apishare_response.received_time = Math.floor(new Date().getTime() / 1000);
            update_ttl();
            await sleep(500);
            const payload = JSON.parse(decrypted.message)

            switch (payload.type) {
                case 'text-tab':
                    msg_rcv_decrypted.value = payload.body;
                    root.querySelector(".message-section-text").style.display = "";
                    break;
                case 'password-tab':
                    passwordMessage.value = payload.body;
                    root.querySelector(".message-section-password").style.display = "";
                    break;
                case 'url-tab':
                    urlMessage.setAttribute('href', payload.body);
                    urlMessage.innerText = payload.body;
                    root.querySelector(".message-section-url").style.display = "";
                    break;
                case 'file-tab':
                    download_button(payload.filename, payload.body);
                    root.querySelector(".message-section-file").style.display = "";
                    break;
                case 'quorum-tab':
                    mod_loader(EndorseModule, { target: ".message-section-quorum", shares_payload: payload, apishare_response, sss_hex: hkey });
                    root.querySelector(".message-section-quorum").style.display = "";
                    break;
                case 'link-device':
                    mod_loader(PrivKeyLinkScanModule, { target: ".section_message_read", link_device: payload });
                    break;
                default:
                    throw Error("Unexpected payload.type received from activeTabId")
            }

            matrix_effect(matrix_effect_node, false);
            return;
        }

        // Cannot decrypt. Error handling

        root.querySelector(".icon_flag_msg_read_card").classList.replace("bi-mailbox", "bi-envelope-slash-fill");
        root.querySelector(".icon_flag_msg_read_card").style.color = "red";

        matrix_effect(matrix_effect_node, false);
        matrix_effect(matrix_effect_node, true, "CANNOT DECRYPT");

        console.log(decrypted)

        const ERR_WRONG_PSK = "Error decrypting message: Session key decryption failed."; // Error from the GPG openpgp.decrypt()
        const ERR_WRONG_PKI = "Error decrypting message: No public key encrypted session key packet found."; // Error from the GPG openpgp.decrypt()

        if (decrypted.error == ERR_WRONG_PSK) {
            collapse_show(root.querySelector(".PSK_NOT_FOR_THIS_MESSAGE"));
        } else if (decrypted.error == "PUBKEY_NOT_FOR_THIS_RCPT") {
            collapse_show(root.querySelector(".PUBKEY_NOT_FOR_THIS_RCPT"))
        } else if (decrypted.error == ERR_WRONG_PKI) {
            root.querySelector(".section_message_401_decryption_error_message").innerText = decrypted.error;
            collapse_show(root.querySelector(".PKI_NOT_FOR_THIS_MESSAGE"))
        } else {
            console.warn(decrypted)
            show_modal("Unexpected decryption error", decrypted.error)
        }

    })

}
// ---- ---- ---- ---- ---- ---- ---- ---- ---- ---- ---- ---- ----
function update_ttl() {
    const now = Math.floor(new Date().getTime() / 1000);
    const seconds = apishare_response.ttl_remaining - (now - apishare_response.received_time);
    message_remaining_ttl.innerText = secondsToHuman(seconds);
    setTimeout(() => { update_ttl(); }, 1000);
}

// ---- ---- ---- ---- ---- ---- ---- ---- ---- ---- ---- ---- ----

async function add_key_and_decrypt(key) {

    root.querySelector(".add_pubkey_panel").classList.remove("show");

    await add_pub_key(key.myKeyPairPublicKey);

    decrypt_message()

}

// ---- ---- ---- ---- ---- ---- ---- ---- ---- ---- ---- ---- ----

function ignore_key_and_decrypt() {

    root.querySelector(".info_untrusted_pubkey_warning").style.display = "";

    root.querySelector(".add_pubkey_panel").classList.remove("show")

    decrypt_message()

}
// ---- ---- ---- ---- ---- ---- ---- ---- ---- ---- ---- ---- ----

function download_button(filename, buffer) {
    downloadFileMessage.addEventListener("click", () => {
        const rawValue = buffer.value;

        // Convert plain object {0: 116, 1: 101, ...} to Uint8Array
        const data = rawValue instanceof Uint8Array
            ? rawValue
            : Uint8Array.from(Object.values(rawValue));

        const blob = new Blob([data], { type: "application/octet-stream" });
        const url = URL.createObjectURL(blob);

        const link = document.createElement("a");
        link.href = url;
        link.download = filename;
        link.click();

        URL.revokeObjectURL(url);
    });
}